import { Component, OnInit,Input } from '@angular/core';
import {AppSettings} from '../../app-settings';


@Component({
  selector: "app-activity-list-view",
  templateUrl: "./activity-list-view.component.html",
  styleUrls: ["./activity-list-view.component.css"],
})
export class ActivityListViewComponent implements OnInit {
  expandIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/expand_icon_hollow.png";
  collapseIconAssetURL: string =
    AppSettings.cdnUrl + "assets/images/collapse_icon_filled.png";
  showStatusTooltip = false;
  showStartStateTooltip = false;
  statusIconClicked = true;
  startStateIconClicked = true;
  activityId;

  @Input() activityList = [];

  status = {
    REVISION: AppSettings.cdnUrl + "assets/images/revision.png",
    NEW: AppSettings.cdnUrl + "assets/images/not_attempted.png",
    COMPLETED_AUTO: AppSettings.cdnUrl + "assets/images/completed.png",
    INPROGRESS: AppSettings.cdnUrl + "assets/images/inprogress.png",
    COMPLETED_MANUAL: AppSettings.cdnUrl + "assets/images/completed_user.png",
  };

  constructor() {}

  ngOnInit() {
    console.log(this.activityList);
  }

  toggleActivityDetails(index, event) {
    this.activityList[index]["detailsCollapsed"] =
      !this.activityList[index]["detailsCollapsed"];
  }

  changeFlag(flag) {
    if (flag === "status_flag") {
      this.showStatusTooltip = this.statusIconClicked;
    } else {
      this.showStartStateTooltip = this.startStateIconClicked;
    }
  }

  changeGradeFlagHover(activity) {
    activity["showTooltip"] = activity["gradeClicked"];
  }

  changeGradeFlagClick(activity, event) {
    if(event.target === event.currentTarget) {
      activity["showTooltip"] = true;
      activity["gradeClicked"] = true;
    }
  }

  // changeShowRecommendedTime(activity) {
  //   activity["showRecommendedTime"] = activity['timeSpentClicked'] === true;
  // }
}
